export default __webpack_public_path__ + "static/media/HTB.a926b16f.svg";